/// <amd-module name="Tfs/ReduxCommon/Modules/TfsPageData/TfsPageDataContracts" />
import { ITfsPageData } from "Tfs/Platform/Page";
export interface ITfsPageDataAwareState {
    tfsPageData: ITfsPageData | null;
}
